<template>
  <Teleport v-if="targetExists" to="#page-header-portal">
    <slot />
  </Teleport>
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from 'vue';

const targetExists = ref(false);
let frameId: number | null = null;

function updateTargetState(): void {
  targetExists.value = !!document.querySelector('#page-header-portal');
}

onMounted(() => {
  updateTargetState();
  frameId = requestAnimationFrame(updateTargetState);
});

onBeforeUnmount(() => {
  if (frameId !== null) cancelAnimationFrame(frameId);
  targetExists.value = false;
});
</script>
